export enum PageContentLayoutSpaceTaken {
    ALL = "ALL",
    MODERATELY = "MODERATELY",
}